import React from 'react';

const ContactPage: React.FC = () => {
  return (
    <main>
      <article>
        <section className="section contact" aria-label="contact">
          <div className="container">
            <p className="section-subtitle label-2 text-center">Get In Touch</p>
            <h2 className="headline-1 section-title text-center">Contact Us</h2>

            <div className="contact-content">
              <div className="contact-text">
                <p className="body-2">
                  Located in Hacienda Heights, California, Happy Valley Village is a must-visit
                  Chinese restaurant that offers a plethora of dining options for its customers.
                  From offering delivery and takeout services to having many vegetarian options and
                  catering services, this restaurant truly caters to all types of diners. What sets
                  Happy Valley Village apart is its commitment to providing a memorable dining
                  experience, with amenities such as covered outdoor seating, private dining, and
                  even heated outdoor seating for those chilly evenings.
                </p>

                <p className="body-2">
                  As a food reviewer, I have had the pleasure of trying out the dishes at Happy
                  Valley Village, and I must say, they did not disappoint. From their flavorful
                  stir-fries to their succulent dumplings, each dish is expertly prepared and
                  bursting with authentic Chinese flavors. What stood out to me the most was the
                  attention to detail in each dish, as well as the fresh ingredients used.
                </p>

                <p className="body-2">
                  Overall, Happy Valley Village is a gem in the Chinese dining scene, and I highly
                  recommend it to anyone looking for a delicious and enjoyable dining experience. Be
                  sure to stop by and indulge in their delectable offerings – you won't be
                  disappointed!
                </p>
              </div>

              <div className="contact-info">
                <h3 className="title-2">Restaurant Information</h3>

                <address className="body-4">
                  1655 S Azusa Ave Ste E <br />
                  Hacienda Heights, CA 91745
                </address>

                <p className="body-4">
                  <strong>Hotline:</strong>{' '}
                  <a href="tel:+16263637268" className="hover-underline">
                    (626) 363-7268
                  </a>
                </p>

                <p className="body-4">
                  <strong>Hours:</strong> 11:30 AM - 2:30 PM, 5:00 PM - 10:00 PM
                </p>
              </div>
            </div>

            {/* Google Maps Embed */}
            <div className="footer-map" style={{ marginBlock: '60px' }}>
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d13224.123456789012!2d-117.9334786!3d33.9921005!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80c2d5ac2590537d%3A0xd8705b352115d687!2sHappy%20Valley%20Village%2F%20Shanlitun!5e0!3m2!1sen!2sus!4v1700000000000!5m2!1sen!2sus"
                width="100%"
                height="400"
                style={{ border: 0, borderRadius: '12px' }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Happy Valley Village Location"
              ></iframe>
            </div>
          </div>
        </section>
      </article>
    </main>
  );
};

export default ContactPage;
